// import queryString from 'query-string';
// import _ from 'lodash';
import { notification } from 'antd';
import axios from 'axios';
import moment from 'moment';

/*import Mock from 'mockjs';*/
import Config, { TIMEOUT, SERVER_PATH } from './config';
//import { hashHistory } from 'react-router';

// function get(url, params) {
//     if (params) {
//         url += '?' + queryString.stringify(params)
//     }
//     return fetch(url)
//         .then((res) => res.json())
//         /*.then((res) => Mock.mock(res))*/
// }
function get(url, params) {
    return axiosFn(url, params, 'get');
}

function post(url, data) {
    return axiosFn(url, data, 'post');
}

function put(url, data) {
    return axiosFn(url, data, 'put');
}

function patch(url, data) {
    return axiosFn(url, data, 'patch');
}

function reqDelete(url, data) {
    return axiosFn(url, data, 'delete');
}


function postForA8bnc2ik(url, data) {
    return axiosFnForA8bnc2ik(url, data, 'post');
}
function axiosFnForA8bnc2ik(url, paramsData, method) {
    let config = {
        url: url,
        method: method,
        timeout: TIMEOUT,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    };

    config.headers['Authorization'] = getToken(true);

    if (method === "get") {
        config.params = paramsData;
    } else {
        config.data = paramsData;
    }

    return axios(config).then(res => {
        return res;
    }).catch(e => {
        let res = e.response;
        if (res && res.status === 401 && res.data && res.data.errcode == 401) {
            window.localStorage.clear();
            //此处先处理SupOS的情况
            // if(process.env.REACT_APP_SUPOS_AUTH === 'true' && !window.reauthing){
            //     window.reauthing = true;
            //     notification.info({ message: '刷新凭证，请稍等...', duration: 1.5});
            //     setTimeout(()=>{
            //         window.location.hash = '/AppAuth';
            //     },800);
            // }
        }
        return { error: true }
        // if(e.response){

        // }else{
        //     //在设置触发错误的请求时发生了错误
        //     console.log('Error',e)
        // }
        // console.log(e.config);
        // return {error:true}
    });
}

function axiosFn(url, paramsData, method) {
    let config = {
        url: url,
        method: method,
        timeout: TIMEOUT,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    };

    if (isOldApi(url) && process.env.REACT_APP_OLD_API_TOKEN) {
        config.headers['Authorization'] = process.env.REACT_APP_OLD_API_TOKEN
    } else {
        if (getToken() != null) {
            config.headers['Authorization'] = getToken();
        }
    }

    if (method === "get") {
        config.params = paramsData;
    } else {
        config.data = paramsData;
    }

    return axios(config).then(res => {
        return res;
    }).catch(e => {
        let res = e.response;
        if (res && res.status === 401 && res.data && res.data.errcode == 401) {
            window.localStorage.clear();
            //此处先处理SupOS的情况
            // if(process.env.REACT_APP_SUPOS_AUTH === 'true' && !window.reauthing){
            //     window.reauthing = true;
            //     notification.info({ message: '刷新凭证，请稍等...', duration: 1.5});
            //     setTimeout(()=>{
            //         window.location.hash = '/AppAuth';
            //     },800);
            // }
        }
        return { error: true }
        // if(e.response){

        // }else{
        //     //在设置触发错误的请求时发生了错误
        //     console.log('Error',e)
        // }
        // console.log(e.config);
        // return {error:true}
    });
}

//获取URL中参数值
function getQueryString(name) {
    /*var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return (r[2]);
    return null;*/

    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.hash.substr(window.location.hash.indexOf('?') + 1).match(reg);
    if (r != null) return (r[2]);
    return null;
}

window.clickElem = function (elem) {
    document.querySelector("#" + elem).click();
}

function roundNum(number, fractionDigits) {
    return Math.round(number * Math.pow(10, fractionDigits)) / Math.pow(10, fractionDigits);
}

export function getFloat(value, digit = 2, fixed = false) {
    // 空值处理
    if (
        value === null ||
        value === undefined ||
        value === "" ||
        isNaN(value)
    ) {
        return fixed ? "--" : null;
    }

    const num = Number(value);

    // 保留小数
    const result = num.toFixed(digit);

    // fixed=true 返回字符串（保留 .00）
    // fixed=false 返回 number
    return fixed ? result : Number(result);
}

function isOldApi(url) {
    if (process.env.REACT_APP_CEMENT_SERVER_PATH && url.indexOf(process.env.REACT_APP_CEMENT_SERVER_PATH) >= 0) {
        return true;
    } else {
        return false;
    }
}

//获取token
function getToken(useExtendToken = false) {
    let userInfo = getCachedUserInfo();

    if (!!userInfo) {
        const { expire_time } = userInfo;
        try {
            if (moment.unix(expire_time).isAfter(moment())) {
                if (useExtendToken) {
                    return `Bearer ${userInfo?.ext_token_data.token || ''}`;
                } else {
                    return userInfo.token;
                }
            };
        } catch (err) { };
    };

    if (
        window.location.hash.indexOf('/Login') !== -1
        || window.location.hash.indexOf('/ExcelDemo') !== -1
        || window.location.hash.indexOf('/OverviewMobile') !== -1
        || window.location.hash.indexOf('/DiagramChart') !== -1
        || window.location.hash.indexOf('/DiagramChartMobile') !== -1
        || window.location.hash.indexOf('/DiagramDisplay') !== -1
        || window.location.hash.indexOf('/DiagramDisplayMobile') !== -1
        || window.location.hash.indexOf('/DiagramListMobile') !== -1
    ) return null;

    if (['wuhu'].includes(process.env.REACT_APP_PROJECT_TAG) || ['null'].includes(process.env.REACT_APP_AUTH_TYPE)) {
        return null;
    } else {
        if (window.token_expired_notification !== true) {
            window.token_expired_notification = true;
            const currHash = (window.location.hash ?? "").replace("#", "");
            if (process.env.REACT_APP_PROJECT_TAG == "shurang") {
                notification['info']({ message: '登陆中...', duration: 2 });
                setTimeout(() => {
                    window.location.hash = `#/AutoLogin${currHash !== "" ? `?redirect=${window.encodeURIComponent(currHash)}` : ""}`;
                }, 800);
            } else {
                notification['error']({ message: '凭证已过期，请重新登录...', duration: 1.5 });
                setTimeout(() => {
                    window.location.hash = `#/Login${currHash !== "" ? `?redirect=${window.encodeURIComponent(currHash)}` : ""}`;
                }, 800);
            }
        };
    }

    return null;
}

function getCachedUserInfo() {
    let userInfo = null;
    if (window.localStorage.getItem('PERSIST_SESSION') == 'true') {
        userInfo = window.localStorage.getItem('USER_INFO');
    } else {
        userInfo = window.localStorage.getItem('USER_INFO');
    }
    if (userInfo) {
        userInfo = JSON.parse(userInfo);
    }
    if (!userInfo || new Date().getTime() / 1000 > userInfo.expire_time) {//token超过6小时即失效
        return null;
    }
    return userInfo;
}

const getCurrentTime = () => {
    const sys_default_time = process.env.REACT_APP_PROJECT_SYSTEM_DEFAULT_TIME;
    let currTime = moment();
    if (typeof sys_default_time === 'string' && sys_default_time !== '') {
        currTime = moment(sys_default_time);
    };
    return currTime;
}

function postDownloadFile(url, params) {
    let form = document.createElement("form");
    form.setAttribute("style", "display:none;");
    form.setAttribute("method", "post");
    form.setAttribute("action", url);

    Object.keys(params).forEach(key => {
        if (Array.isArray(params[key])) {
            // value_list = []
            params[key].forEach(value => {
                let input_item = document.createElement("input");
                input_item.name = key;
                input_item.value = value;
                form.appendChild(input_item);
            })
        } else {
            let input_item = document.createElement("input");
            input_item.name = key;
            input_item.value = params[key];
            form.appendChild(input_item);
        }
    })

    document.body.appendChild(form);
    // let windowName = 'Download(' + (new Date().getTime()) + ')';
    // let w = window.open('', windowName);
    form.target = '_blank';
    form.submit();
    form.remove();
    // w.close();
}

const significantNum = (num, precision = 4, toFix = 3, noNumRet) => {
    if (typeof num !== 'number' || isNaN(num)) {
        if (typeof noNumRet === 'string') return noNumRet;
        return null;
    };
    // num, precision required
    const max = Math.pow(10, precision);
    if (num >= max) {
        return roundNum(num, 0);
    } else {
        // toPrecision会四舍五入
        let tmp = num.toPrecision(precision);
        // 这里还需考虑到小数位在0.000000之后会变得很长，需要定义最长小数位
        const afterDotStr = tmp.split(".")[1] ?? "";
        if (afterDotStr.length > toFix) {
            tmp = roundNum(num, toFix);
        } else {
            tmp = parseFloat(tmp);
        };
        return tmp;
    };
};

const sendStatusInfo = () => {
    const href = window.location.href ?? 'BLANK'
    const userInfo = getCachedUserInfo()
    const name = userInfo?.name ?? 'BLANK'
    // console.log("info", href, name, userId)
    if (window._hmt) {
        window._hmt.push(['_trackEvent', 'Pageview', href, name])
    }
}

export {
    get,
    post,
    put,
    reqDelete,
    patch,
    roundNum,
    significantNum,
    getQueryString,
    getToken,
    getCachedUserInfo,
    getCurrentTime,
    postDownloadFile,
    sendStatusInfo,

    postForA8bnc2ik
}
